module.exports = __webpack_public_path__ + "img/memories.2b79ec21.jpg";